import { Box, Grid2, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { Constants, Page_Padding } from "../../shared/constants";
import { ImgText } from "../../shared/utils/Heading";
import CustomDivider, { OrDivider } from "../../shared/utils/CustomDivider";
import SelectPathCard from "../../shared/components/SelectPathCard";


const SelectPathPage = ({
    title,
    description,
    data,
    bottomText,
    bottomLinkText,
    bottomLinkPath,
    clearSession = false,
}) => {
    const location = useLocation();
    console.log("SelectPathPage received state:", location.state);

    return (
        <Box sx={{ px: Page_Padding, pb: "2%" }}>
            <Link to="/">
                <img
                    src={Constants.customImages.Logo}
                    alt="logo"
                    width="200px"
                    height="auto"
                />
            </Link>

            <Grid2 container gap="2rem">
                <Grid2 size={{ xs: 12, md: 5 }}>
                    <ImgText text="We're Excited to Have You!" />
                    <Typography variant="h2">{title}</Typography>
                    <CustomDivider size="2rem" />
                    <Typography variant="body1">{description}</Typography>
                    <CustomDivider size="1rem" />

                    {data.map((item, index) => (
                        <SelectPathCard item={item} key={index} />
                    ))}

                    <CustomDivider />
                    <Grid2 xs={12}>
                        <OrDivider text="Or" />
                    </Grid2>
                    <Grid2
                        xs={12}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        gap="0.25rem"
                    >
                        <Typography variant="body2" fontSize="12px">
                            {bottomText}
                        </Typography>
                        <Link to={bottomLinkPath}>
                            <Typography variant="body2" fontSize="12px" color="red.main">
                                {bottomLinkText}
                            </Typography>
                        </Link>
                    </Grid2>
                </Grid2>

                <Grid2
                    size={{ xs: 12, md: 6.5 }}
                    sx={{
                        backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${Constants.customImages.AuthBgImg})`,
                        backgroundSize: "cover",
                        backgroundPosition: "top",
                        backgroundRepeat: "no-repeat",
                        display: "flex",
                        alignItems: "flex-end",
                        py: "1rem",
                        borderRadius: "1rem",
                        height: { xs: "400px", md: "auto" },
                    }}
                >
                    <Box
                        sx={{
                            background:
                                "linear-gradient(86.76deg, rgba(62, 62, 62, 0.4) 5.06%, rgba(0, 0, 0, 0.78) 95.97%)",
                            py: "2rem",
                            width: "100%",
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, textAlign: "center", color: "primary.main" }}
                        >
                            We nurture your child’s growth, guiding them to become <br />
                            confident, mentally, and emotionally.
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: "red.main", textAlign: "center" }}
                        >
                            Your child’s success is our promise
                        </Typography>
                    </Box>
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default SelectPathPage;
